type ClusterChild = {
  id: string;
  type: string;
  style?: string;
  blocks?: ClusterChild[];
};

export type ClusterSplitItem<T extends ClusterChild> =
  | { kind: 'cluster'; items: T[] }
  | { kind: 'structural'; node: T };

function isLeafText(node: ClusterChild): boolean {
  if (node.type !== 'text') return false;
  const children = node.blocks ?? [];
  return children.length === 0;
}

function leafStyle(node: ClusterChild): string {
  return node.style ?? 'body';
}

export function splitChildrenIntoClusters<T extends ClusterChild>(
  children: T[],
): ClusterSplitItem<T>[] {
  const result: ClusterSplitItem<T>[] = [];
  let buffer: T[] = [];
  const flush = () => {
    if (buffer.length > 0) {
      result.push({ kind: 'cluster', items: buffer });
      buffer = [];
    }
  };
  for (const child of children) {
    if (isLeafText(child)) {
      if (
        buffer.length > 0 &&
        leafStyle(buffer[0]) !== leafStyle(child)
      ) {
        flush();
      }
      buffer.push(child);
    } else {
      flush();
      result.push({ kind: 'structural', node: child });
    }
  }
  flush();
  return result;
}
